// Differential pressure name mapping with attribute identifier
export const diffPressureMapMax = {
  EGTF_6051_NU_FLOAT: 'Maximum (5) bar',
  EGTF_6052_NU_FLOAT: 'Maximum (10) bar',
  EGTF_6053_NU_FLOAT: 'Maximum (16) bar',
  EGTF_6054_NU_FLOAT: 'Maximum (20) bar',
  EGTF_6055_NU_FLOAT: 'Maximum (40) bar',
  EGTF_6056_NU_FLOAT: 'Maximum (50) bar',
  EGTF_6057_NU_FLOAT: 'Maximum (63) bar',
  EGTF_6058_NU_FLOAT: 'Maximum (100) bar',
};

export const diffPressureMap = {
  EGTF_6051_NU_FLOAT: '5 bar',
  EGTF_6052_NU_FLOAT: '10 bar',
  EGTF_6053_NU_FLOAT: '16 bar',
  EGTF_6054_NU_FLOAT: '20 bar',
  EGTF_6055_NU_FLOAT: '40 bar',
  EGTF_6056_NU_FLOAT: '50 bar',
  EGTF_6057_NU_FLOAT: '63 bar',
  EGTF_6058_NU_FLOAT: '100 bar',
};

export const getDiffPressureFilterAttr = filterDiffAttr => {
  return {
    identifier: 'Differential Pressure',
    component: 'select',
    displayComponent: 3,
    attributeIdentifier: 'DifferentialPressure',
    values: filterDiffAttr,
    translationId: 'filters.actuator.displayName.DifferentialPressure',
    displayName: 'Differential Pressure',
  };
};
